import request from '../../axios';

const PatchFertilizerRequirement = async (
  payload: IFertilizerRequirementPayload,
  guid?: string,
) => {
  const newPayload = {
    title: payload.title,
    sub_input: payload.sub_input?.guid,
    location: `POINT (${payload.location?.lng} ${payload.location?.lat})`,
    ad_type: payload.ad_type,
    wanted_weight: payload.wanted_weight,
    weight_unit: payload?.weight_unit?.value,
    brs_type: payload.srs_type?.type,
    only_massage_buyer: payload.only_massage_buyer || false,
    type: payload?.type?.value,
    is_change_title: payload?.is_change_title,
    filter: 'requirement',
  };
  const response = await request.patch(`api/v2/store/advertisement/${guid}`, {
    ...newPayload,
  });
  return response.data;
};

export default PatchFertilizerRequirement;
